import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const PrivateRoute = ({ children, requiredRole }) => {
  const { authToken, orgData } = useContext(AuthContext);
  const location = useLocation();

  if (!authToken) {
    localStorage.setItem("lastPath", location.pathname);
    return <Navigate to="/login" />;
  }

  if (requiredRole && !orgData?.role?.toLowerCase().includes(requiredRole?.toLowerCase())) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
